import React, { Fragment, Component } from 'react';
import { loadMy, loadUser } from '../../actions/user'
import { connect } from 'react-redux'
import {Icon} from 'antd'
import PostGrid from '../../PostGrid'
import PostForm from '../../PostForm'
import withSizes from 'react-sizes'
import back from '../../images/back.png'
import history from '../../history'
import Intro from '../../Intro'
import home from '../../images/home.png'
import Masonry from 'react-masonry-component';
import './User.css'
import WXConfig from "../../WXConfig";



class User extends Component {

  componentDidMount(){
    let {match:{params:{_id}}} = this.props
    this.props.loadUser(_id)
  }

  renderPosts(){
    const {posts, my, user} = this.props
    let title = '发布'
    if(my && user && my._id == user._id){
      title = '我的发布'
    }else if(user && user.weixin){
      title = user.weixin.nickname+'的发布'
    }
    return <div className={"user-posts"}>
      <div className={"title"}>{title}</div>
      {
        (posts && posts.length > 0) && <Masonry
          style={{margin: '0 -5px'}}
          options={{
            transitionDuration: 300
          }}
        >
          {
            posts.map(post => {
              if (!(user && my && user._id === my._id) && post.anonymous) {
                return null
              } else {
                return <PostGrid
                  key={post._id}
                  post={post}
                  del={user && my && user._id === my._id}
                  style={{
                    width: 'calc(50% - 10px)',
                    padding: 10,
                    margin: 5,
                  }}
                />
              }
            })
          }
        </Masonry>
      }
      {
        (!posts || posts.length === 0) && <div className={'no-content'}>
          暂无内容
        </div>
      }
    </div>
  }

  renderRelatedPosts(){
    const {myComments, user, my} = this.props
    return <div className={"user-myComments"}>
      <div className={"title"}>我的参与</div>
      {
        (myComments.posts && myComments.posts.length !== 0) && <Masonry
          style={{
            margin: '0 -5px'
          }}
          options={{
            transitionDuration: 300
          }}
        >
          {myComments.posts.map(post => (<PostGrid
            post={post}
            key={post._id}
            style={{
              width: 'calc(50% - 10px)',
              padding: 10,
              margin: 5,
            }}
          />))}
        </Masonry>
      }
      {
        (!myComments.posts || myComments.posts.length === 0) && <div className={'no-content'}>
            暂无内容
        </div>
      }

    </div>
  }

  render() {
    const {
      loadingPosts,
      loadingPostsError,
      user,
      my
    } = this.props
    return <div
      className="home-posts-container"
    >
      {
        loadingPostsError && <span className={'center danger'}>
          {loadingPostsError}
        </span>
      }
      {
        (!loadingPostsError && loadingPosts) && <span className={'center'}>
          <Icon type="loading" className={'loading-icon center'} />
          <span className={'text'}>载入中...</span>
        </span>
      }
      {
        (!loadingPostsError && !loadingPosts) && <Fragment>
          <div className="home-posts-container">
            <div
              className={"home-posts-back"}
              style={{
                backgroundImage: `url(${back})`
              }}
              onClick = {()=> {
                history.goBack()
              }}
            />
            <div
              className={"home-posts-home"}
              style={{
                backgroundImage: `url(${home})`
              }}
              onClick = {()=> {
                history.push('/')
              }}
            />
            {user && user.weixin &&
            <div
              className={"home-posts-header"}
              style={{
                backgroundImage: `url(${user.weixin.headimgurl})`
              }}
            />
            }
            <div className={"posts-content-container"}>
              {this.renderPosts()}
              {user && my && user._id === my._id && this.renderRelatedPosts()}
            </div>
          </div>
          <PostForm />
          <Intro />
          {user  &&
          <WXConfig
            title={`${user.weixin.nickname}在「你好，朋友」`}
            link={window.location.href}
            desc={"你好朋友，我有一个问题"}
          />
          }
        </Fragment>
      }
    </div>
  }
}

const mapStateToProps = (state, ownProps) => {
  let {match:{params:{_id}}} = ownProps
  return {
    posts: state.user.posts[_id],
    user: state.user.users[_id],
    my: state.user.my,
    myComments: state.user.myComments,
    myPostLikes: state.user.myPostLikes,
    myCommentLikes: state.user.myCommentLikes,
    loadingPosts: state.user.loadingPosts,
    loadingPostsError: state.user.loadingPostsError,
    loadingComments: state.user.loadingComments,
    loadingCommentsError: state.user.loadingCommentsError,
    loadingLikes: state.user.loadingLikes,
    loadingLikesError: state.user.loadingLikesError
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadMy: ()=>dispatch(loadMy()),
    loadUser: (_id)=>dispatch(loadUser(_id)),
  }
}

const mapSizesToProps = ({ width, height }) => {
  return {width, height}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSizes(mapSizesToProps)(User))




// WEBPACK FOOTER //
// ./src/routes/user/User.js